(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = window.app && window.app.data && window.app.data.money_format;
      return window.Shopify.formatMoney(cents, format || '${{amount}}');
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function initProductVariants(container) {
    var jsonNode = container.querySelector('.product-json');
    var variantSelect = container.querySelector('select.product-variants');
    var optionSelectors = Array.prototype.slice.call(
      container.querySelectorAll('.main-product-select .single-option-selector')
    );

    if (!jsonNode || !variantSelect || !optionSelectors.length) return;

    var product;
    try {
      product = JSON.parse(jsonNode.textContent || jsonNode.innerText || '{}');
    } catch (error) {
      return;
    }

    if (!product || !Array.isArray(product.variants)) return;

    function findVariant() {
      var values = optionSelectors.map(function (selector) {
        return String(selector.value || '').trim();
      });

      return product.variants.find(function (variant) {
        return values.every(function (value, index) {
          return String(variant.options[index] == null ? '' : variant.options[index]).trim() === value;
        });
      }) || null;
    }

    function updateVariant(variant) {
      if (!variant) return;

      variantSelect.value = String(variant.id);
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

      var price = container.querySelector('#productPrice');
      if (price) price.innerHTML = formatMoney(variant.price);

      var compare = container.querySelector('#comparePrice');
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.innerHTML = formatMoney(variant.compare_at_price);
          compare.style.display = '';
        } else {
          compare.style.display = 'none';
        }
      }

      var sku = container.querySelector('.variant-sku');
      if (sku) {
        sku.innerHTML = variant.sku
          ? '<b>SKU: </b>' + String(variant.sku).replace(/[&<>"']/g, function (character) {
              return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
            })
          : '';
      }

      var addToCart = container.querySelector('#addToCart');
      if (addToCart) {
        addToCart.disabled = !variant.available;
        addToCart.classList.toggle('disabled', !variant.available);
        addToCart.value = variant.available ? 'Add to Cart' : 'Sold out';
      }

      if (window.history && window.history.replaceState) {
        var url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: url }, '', url);
      }
    }

    optionSelectors.forEach(function (selector) {
      selector.addEventListener('change', function () {
        updateVariant(findVariant());
      });
    });

    var currentId = new URLSearchParams(window.location.search).get('variant');
    var initialVariant = product.variants.find(function (variant) {
      return String(variant.id) === String(currentId);
    }) || findVariant() || product.variants.find(function (variant) { return variant.available; }) || product.variants[0];

    if (initialVariant) {
      initialVariant.options.forEach(function (value, index) {
        if (optionSelectors[index]) optionSelectors[index].value = value;
      });
      updateVariant(initialVariant);
    }
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-section-type="product-page-section"]'),
      initProductVariants
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
